// src/screens/Vendor/VendorPayoutScreen.js
import React, { useContext, useState } from 'react';
import CountContext from '../../context/CountContext.js';

export default function VendorPayoutScreen({ onNext, onBack }) {
  const { state, dispatch } = useContext(CountContext);
  // Initialize with at least one payout row as strings to preserve decimals
  const initialPayouts = state.vendorPayouts && state.vendorPayouts.length
    ? state.vendorPayouts.map(v => ({ description: v.description, amount: v.amount.toFixed(2) }))
    : [{ description: '', amount: '0.00' }];
  const [payouts, setPayouts] = useState(initialPayouts);

  // Sanitize the amount input to allow up to two decimals
  const sanitizeAmount = raw => {
    const cleaned = raw.replace(/[^0-9.]/g, '');
    const match = cleaned.match(/^(\d*)(?:\.(\d{0,2}))?/);
    if (!match) return '';
    const intPart = match[1] || '';
    const decPart = match[2] !== undefined ? '.' + match[2] : '';
    return intPart + decPart;
  };

  const handleChange = (index, field) => e => {
    const value = field === 'amount'
      ? sanitizeAmount(e.target.value)
      : e.target.value;
    setPayouts(prev => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [field]: value };
      return copy;
    });
  };

  const handleAdd = () => {
    setPayouts(prev => [...prev, { description: '', amount: '0.00' }]);
  };

  const handleRemove = index => {
    setPayouts(prev => prev.filter((_, i) => i !== index));
  };

  const handleConfirm = () => {
    // Convert string amounts back to numbers
    const parsed = payouts.map(v => ({
      description: v.description,
      amount: parseFloat(v.amount) || 0
    }));
    dispatch({ type: 'SET_VENDOR_PAYOUTS', payload: parsed });
    onNext();
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg space-y-4">
      <h2 className="text-2xl font-bold">Vendor Payouts</h2>
      {payouts.map((v, i) => (
        <div key={i} className="flex items-center space-x-2">
          <input
            type="text"
            placeholder="Description"
            value={v.description}
            onChange={handleChange(i, 'description')}
            className="border rounded p-1 flex-1"
          />
          <input
            type="text"
            placeholder="Amount"
            value={v.amount}
            onChange={handleChange(i, 'amount')}
            className="border rounded p-1 w-24 text-right"
          />
          {payouts.length > 1 && (
            <button
              onClick={() => handleRemove(i)}
              className="text-red-500 text-xl font-bold"
            >
              ×
            </button>
          )}
        </div>
      ))}
      <button
        onClick={handleAdd}
        className="px-4 py-2 bg-gray-200 rounded"
      >
        Add Payout
      </button>

      <div className="flex justify-between mt-4">
        <button onClick={onBack} className="px-4 py-2 bg-gray-300 rounded">
          Back
        </button>
        <button onClick={handleConfirm} className="px-4 py-2 bg-blue-500 text-white rounded">
          Confirm Payouts
        </button>
      </div>
    </div>
  );
}
